module.exports = __webpack_public_path__ + "img/case2.c9ef320e.png";